//Compoent: TestingCommissionRegister.js
//Description: This Page is used for Testing Commission Register

import React from 'react';
import TCAssetMain from '../../components/testingcommission_components/TCAssetMain';

function TestingCommissionRegister({renderPageContent}) {
    return (
        <>
            <TCAssetMain renderPageContent={renderPageContent}/>      
        </>
    )
}

export default TestingCommissionRegister;